/**
 * DREAM STACK (wishlist) page behavior.
 *
 * Backend contract expected at /apps/einstein/saved-items/details?state=wishlist
 * Response: { items: [ { item_id, variant_id, title, url, image, price, available } ] }
 *
 * NOTE: `state` stays 'wishlist' in the API. "Dream Stack" is display-only.
 */
(function () {
  var BASE = '/apps/einstein/saved-items';
  var DETAILS = BASE + '/details?state=wishlist';

  var root = document.querySelector('[data-dream-stack]');
  if (!root || root.dataset.loggedIn !== 'true') return;

  var listEl = root.querySelector('[data-dream-stack-list]');
  var statusEl = root.querySelector('[data-dream-stack-status]');
  var emptyEl = root.querySelector('[data-dream-stack-empty]');

  function formatPrice(value) {
    // Contract: backend returns integer cents (e.g. 500 = $5.00).
    // Null/missing price means no resolvable variant - render nothing.
    if (value === null || value === undefined || value === '') return '';
    var cents = Number(value);
    if (!isFinite(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function showEmpty() {
    if (statusEl) statusEl.hidden = true;
    if (listEl) listEl.hidden = true;
    if (emptyEl) emptyEl.hidden = false;
  }

  function setStatus(message) {
    if (!statusEl) return;
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  function buildRow(item) {
    var li = document.createElement('li');
    li.className = 'dream-stack__item';
    li.setAttribute('data-item-id', item.item_id);

    var link = document.createElement('a');
    link.className = 'dream-stack__link';
    link.href = item.url || '#';

    if (item.image) {
      var img = document.createElement('img');
      img.className = 'dream-stack__image';
      img.src = item.image;
      img.alt = item.title || '';
      img.loading = 'lazy';
      link.appendChild(img);
    }

    var details = document.createElement('div');
    details.className = 'dream-stack__details';

    var title = document.createElement('span');
    title.className = 'dream-stack__title';
    title.textContent = item.title || 'Untitled';
    details.appendChild(title);

    var price = document.createElement('span');
    price.className = 'dream-stack__price';
    price.textContent = formatPrice(item.price);
    details.appendChild(price);

    link.appendChild(details);
    li.appendChild(link);

    var actions = document.createElement('div');
    actions.className = 'dream-stack__actions';

    // Move to cart - only if we have a variant id and it's in stock.
    if (item.variant_id && item.available !== false) {
      var moveBtn = document.createElement('button');
      moveBtn.type = 'button';
      moveBtn.className = 'dream-stack__move button';
      moveBtn.textContent = 'Move to cart';
      moveBtn.addEventListener('click', function () {
        moveToCart(li, item, moveBtn);
      });
      actions.appendChild(moveBtn);
    } else if (item.available === false) {
      var sold = document.createElement('span');
      sold.className = 'dream-stack__sold';
      sold.textContent = 'Sold out';
      actions.appendChild(sold);
    }

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'dream-stack__remove';
    removeBtn.textContent = 'Remove';
    removeBtn.setAttribute('aria-label', 'Remove ' + (item.title || 'item'));
    removeBtn.addEventListener('click', function () {
      removeItem(li, item, removeBtn);
    });
    actions.appendChild(removeBtn);

    li.appendChild(actions);
    return li;
  }

  function checkEmpty() {
    if (listEl && listEl.children.length === 0) showEmpty();
  }

  function moveToCart(li, item, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';

    // 1) Add to the real Shopify cart.
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: item.variant_id, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed');
        // 2) Transition the saved_items row wishlist -> cart (UPDATE, not delete).
        return fetch(BASE, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ item_id: item.item_id, state: 'cart' }),
        });
      })
      .then(function () {
        li.remove();
        checkEmpty();
      })
      .catch(function (err) {
        console.error('[dream-stack] move to cart failed', err);
        btn.disabled = false;
        btn.textContent = 'Move to cart';
      });
  }

  function removeItem(li, item, btn) {
    btn.disabled = true;
    fetch(BASE + '/' + encodeURIComponent(item.item_id), {
      method: 'DELETE',
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('delete failed');
        li.remove();
        checkEmpty();
      })
      .catch(function (err) {
        console.error('[dream-stack] remove failed', err);
        btn.disabled = false;
      });
  }

  fetch(DETAILS, { credentials: 'same-origin' })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function (data) {
      var items = Array.isArray(data) ? data : data.items || [];
      if (!items.length) return showEmpty();

      items.forEach(function (item) {
        listEl.appendChild(buildRow(item));
      });

      statusEl.hidden = true;
      listEl.hidden = false;
    })
    .catch(function (err) {
      console.error('[dream-stack] load failed', err);
      setStatus("Couldn't load your Dream Stack. Please refresh.");
    });
})();
